import React from "react";
import { Row, Col } from "../../ui/Grid";

const PLATFORM_ICONS = {
  Facebook: "🔵",
  Instagram: "📸",
  X: "🐦",
  LinkedIn: "💼",
  YouTube: "🎬",
  TikTok: "🎵",
  Pinterest: "📌",
};

const SocialProfiles = ({ auditInfo }) => {
  const hasSocial = auditInfo.HasSocialProfiles;
  const profiles = auditInfo.SocialProfiles || [];

  return (
    <div className="featureblock-container">
      <div className="card-header">
        <span>Réseaux sociaux</span>
      </div>
      <div className="card-graph-body">
        <div className="sumup-category">
          <Row>
            <Col xl={10} lg={10} sm={24} className="progress-category">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 68,
                  height: 68,
                  borderRadius: "50%",
                  background: hasSocial ? "#f6ffed" : "#fff2f0",
                  border: `2px solid ${hasSocial ? "#52c41a" : "#ff4d4f"}`,
                  fontSize: 28,
                  margin: "0 auto",
                }}
              >
                {hasSocial ? "✅" : "❌"}
              </div>
            </Col>
            <Col xl={14} lg={14} sm={24}>
              <div style={{ marginTop: "20px" }}>
                Les réseaux sociaux liés à votre fiche Google Business Profile
                renforcent votre présence en ligne et votre crédibilité. Ils
                permettent à vos clients de vous retrouver facilement sur leurs
                plateformes préférées.
              </div>
            </Col>
          </Row>
        </div>
        <div className="criteria-audit">
          <Row gutter={30}>
            <Col xl={14} lg={14} sm={24}>
              <div className="criteria-status">
                <span>
                  {hasSocial ? (
                    <>
                      <span
                        role="img"
                        className="issue-icon"
                        aria-label="check"
                      >
                        ✅
                      </span>
                      Réseaux sociaux détectés ({profiles.length})
                    </>
                  ) : (
                    <>
                      <span
                        role="img"
                        className="issue-icon"
                        aria-label="cross"
                      >
                        ❌
                      </span>
                      Aucun réseau social détecté
                    </>
                  )}
                </span>
              </div>
              {hasSocial && profiles.length > 0 && (
                <div style={{ margin: "15px 0" }}>
                  {profiles.map((platform) => (
                    <span
                      key={platform}
                      style={{
                        display: "inline-block",
                        background: "#f5f5f5",
                        borderRadius: "6px",
                        padding: "6px 14px",
                        marginRight: "8px",
                        marginBottom: "8px",
                        fontSize: "14px",
                      }}
                    >
                      {PLATFORM_ICONS[platform] || "🔗"} {platform}
                    </span>
                  ))}
                </div>
              )}
              <div className="criteria-description">
                <span>
                  Ajoutez vos profils de réseaux sociaux à votre fiche Google
                  Business Profile pour renforcer votre visibilité.
                  <br />
                  <br />
                  Les plateformes recommandées sont Facebook, Instagram,
                  LinkedIn, YouTube et X (Twitter).
                  <br />
                  <br />
                  <b>
                    Les liens vers vos réseaux sociaux apparaissent directement
                    sur votre fiche dans les résultats de recherche Google.
                  </b>
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SocialProfiles;
